export const CONTENTFUL_DISCLAIMER = {
  HP: 'hpDisclaimers',
  PDP: 'pdpDisclaimers',
  CLP: 'clpDisclaimers',
  ANGEBOTE: 'angeboteDisclaimers',
};
